import { UPDATE_REPORT, SAVE_REPORT, NEW_REPORT, DELETE_REPORT } from 'lib/api/rideReports'
import { pending, fulfilled, rejected } from 'lib/promiseMiddlewareHelpers'
import { Map, Record, Set } from 'immutable'
import { combineReducers } from 'redux'
import _ from 'lodash'

const ReportState = Record({ savePending: false, saveFailed: false, unsavedChanges: null, failedSaves: 0 })

const randomId = () => Math.random().toString(36).substr(2)

const saveState = (state = Map(), action) => {
  switch (action.type) {
    case UPDATE_REPORT: {
      const reportState = state.get(action.report.id) || new ReportState()
      return state.set(action.report.id, reportState.merge({ unsavedChanges: randomId() }))
    }
    case pending(SAVE_REPORT): {
      const reportId = action.meta.report.id
      const reportState = state.get(reportId) || new ReportState()
      if (reportState.savePending) {
        if (process.env.NODE_ENV === 'development') {
          window.alert('Race condition detected - report save fired while another save was pending')
        }
        throw Error('Race condition detected - report save fired while another save was pending')
      }
      return state.set(reportId, reportState.merge({ savePending: reportState.unsavedChanges || randomId() }))
    }
    case fulfilled(SAVE_REPORT): {
      const reportId = action.meta.report.id
      const reportState = state.get(reportId)
      let unsavedChanges = reportState.unsavedChanges
      if (unsavedChanges === reportState.savePending) {
        unsavedChanges = null
      }
      return state.set(reportId, reportState.merge({
        savePending: false,
        saveFailed: false,
        failedSaves: 0,
        unsavedChanges
      }))
    }
    case rejected(SAVE_REPORT): {
      const reportId = action.meta.report.id
      const reportState = state.get(reportId)
      // TODO better save failure error handling
      return state.set(reportId, reportState.merge({
        savePending: false,
        saveFailed: true,
        failedSaves: reportState.failedSaves + 1
      }))
    }
    default:
      return state
  }
}

const initialState = Set(
  _.get(window, 'rwgps.config.rideReports.draftList', [])
)

const draftList = (state = initialState, action = {}) => {
  switch (action.type) {
    case fulfilled(NEW_REPORT):
      return state.add(action.payload.report.id)
    case fulfilled(DELETE_REPORT):
      return state.delete(action.payload.report.id)
    case fulfilled(SAVE_REPORT):
      if (action.payload.report.publish_status === 0) {
        return state.add(action.payload.report.id)
      } else {
        return state.delete(action.payload.report.id)
      }
    default:
      return state
  }
}

export default combineReducers({
  saveState,
  draftList
})
